// @ts-nocheck
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import getSampleProductInfo from "@store/Framework/Common/Utilities/samples/getSampleProductInfo";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";

const getSampleProductContext = (baseProductContext: ProductContextModel) => {
    return mergeProps<ProductContextModel>(baseProductContext, {
        productInfo: getSampleProductInfo(baseProductContext.productInfo),
    } as ProductContextModel);
};

export default getSampleProductContext;
